
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/compress-png",
      function () {
        return require("private-next-pages/compress-png/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/compress-png"])
      });
    }
  